<template>
  <div class="keepwarp">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span><i class="el-icon-s-order elcao"></i>操作手册</span>
      </div>
      <div class="text item">
        <el-table :data="tabledata" border style="width: 100%" :header-cell-style="{textAlign: 'center'}" center max-height="670" :cell-style="{ textAlign: 'center' }">
          <el-table-column type="index" width="50"></el-table-column>
          <el-table-column prop="ctitle" label="手册名称"></el-table-column>
          <el-table-column label="操作" width="100">
            <template slot-scope="scope">
              <el-button size="mini" type="primary" @click="handleEdit(scope.$index, scope.row)" plain>下载</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-card>
  </div>
</template>
<script>
export default {
  data() {
    return {
      tabledata: [],
    };
  },
  created() {
    this.GetOperationManualList();
  },
  methods: {
    // 厂商操作手册
    GetOperationManualList() {
      this.$axios({
        method: "post",
        url: "CommonModule/Op_Supplier/GetOperationManualList",
      }).then((res) => {
        console.log(res, "厂商操作手册");
        if (res.data.Success) {
          this.tabledata = res.data.Data;
        } else {
          this.$message.error(res.data.Message);
        }
      });
    },
    handleEdit(index, row) {
      if (row.cfileurl != "") {
        // 根据浏览地址下载文件;
        const a = document.createElement("a");
        let urlblob = this.global.bxiosdow + row.cfileurl;
        if (
          urlblob.indexOf(".rar") ||
          urlblob.indexOf(".zip") ||
          urlblob.indexOf(".7z")
        ) {
          window.open(urlblob);
        } else {
          fetch(urlblob)
            .then((res) => res.blob())
            .then((blob) => {
              // 将链接地址字符内容转变成blob地址
              a.href = URL.createObjectURL(blob);
              console.log(a.href);
              a.download = ""; // 下载文件的名字
              document.body.appendChild(a);
              a.click();
            });
        }

        // window.open(urlblob);
        // var x = new XMLHttpRequest();
        // x.open("GET", urlblob, true);
        // x.responseType = "blob";
        // this.saveAs(
        //   new Blob([x], { type: "text/plain;charset=UTF-8" }),
        //   "合同模板"
        // );
      } else {
        this.$message.error("暂无文件");
      }
    },
  },
};
</script>







